<div
  class="bm-search-input-container"
  [ngClass]="{ minimal: headerHaveBreadcrumb, active: !headerHaveBreadcrumb }"
  (clickOutside)="onClickedOutside()"
>
  <input
    class="search-input"
    [formControl]="searchInput"
    type="text"
    aria-label="Search"
    [ngClass]="{
      'not-focused': inputNotFocused,
      'have-value': searchInput?.value
    }"
    placeholder="{{ 'search-placeholder' | translate }}"
    (focus)="inputNotFocused = false"
    (blur)="inputNotFocused = true"
    (click)="showSuggestions()"
  />
  <ul class="search-results" *ngIf="showResults" (click)="showResults = false">
    <div
      *ngIf="results.length > 0"
      [ngClass]="{ 'without-more': results.length <= 10 }"
    >
      <li
        *ngFor="let result of results | slice: 0:10"
        (click)="goToDetails(result.id, result.title, result.type)"
      >
        <div
          class="icon"
          [ngClass]="{
            destination: result.type === 0,
            place: result.type === 1
          }"
        ></div>
        <div class="about">
          <div class="title-address">
            <div class="title">{{ result.title }}</div>
            <div class="address">{{ result.address }}</div>
          </div>
          <div class="image" [ngStyle]="getResultImage(result)"></div>
        </div>
      </li>
      <div class="more-content" *ngIf="results.length > 10">
        <a class="bm-link">{{ 'more-results' | translate }}</a>
      </div>
    </div>
    <div
      class="search-suggestions"
      *ngIf="!results.length"
      [ngClass]="{ 'without-more': suggestions.length <= 3 }"
    >
      <div class="suggestions-title">
        {{ 'SUGGESTIONS' | translate }}
      </div>
      <li
        *ngFor="let suggestion of suggestions | slice: 0:3"
        (click)="goToSuggestion(suggestion)"
      >
        <div class="icon destination"></div>
        <div class="about">
          <div class="title-address">
            <div class="title">{{ suggestion.title }}</div>
            <div class="address">{{ suggestion.address }}</div>
          </div>
          <div class="image" [ngStyle]="getSuggestionImage(suggestion)"></div>
        </div>
      </li>
      <div class="more-content" *ngIf="suggestions.length > 3">
        <a class="bm-link">{{ 'more-destinations' | translate }}</a>
      </div>
    </div>
  </ul>
</div>
